import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import {SetProperties} from "@/models/SetProperties";

export class EducationParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(Education.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, Education.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)))
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => Education.build(el))
    }
    return this
  }
}

export class Education extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.application = null
    this.series = null
    this.number = null
    this.issueDate = null
    this.educationDocType = null

    this.filesData = {}
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      series: this.series,
      number: this.number,
      issueDate: this.issueDate,
      educationDocType: this.educationDocType,
    }
  }

  static build(obj) {
    const _this = new Education()
    if (obj) {
      _this.id = obj.id
      _this.application = obj.application
      _this.series = obj.series
      _this.number = obj.number
      _this.issueDate = obj.issueDate
      _this.educationDocType = obj.educationDocType
    }
    return _this
  }
}
